module.exports = __webpack_public_path__ + "img/lFwd.3209a2fa.svg";